import React from "react";
import "./PropList.css";

export default function PropList() {
  return (
    <div className="propLMn">
      <div className="maxW propGrid">

        <div className="propBox">
          <p className="propLabel">SIZE</p>
          <p className="propValue">1200–2500 Sq Ft</p>
        </div>

        <div className="propBox">
          <p className="propLabel">PRICE</p>
          <p className="propValue">₹59 Lakh*</p>
        </div>

        <div className="propBox">
          <p className="propLabel">TOTAL AREA</p>
          <p className="propValue">On Request</p>
        </div>

        <div className="propBox">
          <p className="propLabel">POSSESSION</p>
          <p className="propValue">On Request</p>
        </div>

      </div>
    </div>
  );
}
